import React, { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { fmtDate } from "../lib/format";
import { Bell, AlertTriangle, AlertOctagon, CheckCircle2 } from "lucide-react";

const ICONS = { info: Bell, warning: AlertTriangle, danger: AlertOctagon, success: CheckCircle2 };
const BG = { info: "bg-[var(--info-soft)] text-[var(--brand)]", warning: "bg-[var(--warning-soft)] text-[var(--warning-text)]", danger: "bg-[var(--danger-soft)] text-[var(--danger)]", success: "bg-[var(--success-soft)] text-[var(--success-text)]" };

export default function Notifications() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/notifications");
    setItems(data);
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    load();
  };

  return (
    <div className="space-y-4">
      <div className="card-soft px-5 py-4">
        <div className="text-xs text-[var(--text-2)] font-medium">Central</div>
        <h1 className="font-display text-2xl font-bold tracking-tight mt-0.5">{t("nav_notifications")}</h1>
      </div>

      <div className="space-y-2">
        {items.length === 0 && <div className="card-soft p-10 text-center text-[var(--text-2)]">{t("no_alerts")}</div>}
        {items.map((n) => {
          const Icon = ICONS[n.level] || Bell;
          const iconCls = BG[n.level] || BG.info;
          return (
            <div key={n.id} className={`card-soft p-4 flex items-start gap-3 ${n.read ? "opacity-60" : ""}`} data-testid={`notif-${n.id}`}>
              <div className={`w-10 h-10 rounded-2xl flex items-center justify-center shrink-0 ${iconCls}`}>
                <Icon size={17} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm">{n.title}</div>
                <div className="text-sm text-[var(--text-2)] mt-0.5">{n.message}</div>
                <div className="text-[10px] font-mono text-[var(--text-3)] mt-1.5">{fmtDate(n.created_at)}</div>
              </div>
              {!n.read && (
                <button onClick={() => markRead(n.id)} className="text-xs font-semibold rounded-xl px-3 h-8 bg-[var(--surface-2)] hover:bg-[var(--brand-soft)] hover:text-[var(--brand)]" data-testid={`mark-read-${n.id}`}>
                  Marcar lida
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
